import type { StackProps } from "@mui/material"
import { Stack } from "@mui/material"

export const Actions = (props: StackProps) => (
	<Stack spacing={2} mt={2} alignSelf='end' direction='row' {...props} />
)
